import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../common/types';
import { demoArtistMessages } from './demoArtistMessages';
import styles from './DemoArtistTag.module.scss';

/** design: music24-demo-artist a1/a3. The quiet "Example" tag after the demo artist's name. */
const DemoArtistTagComponent: React.FC = () => {
  const intl = useIntl();
  return <span className={styles.tag}>{intl.formatMessage(demoArtistMessages.tag)}</span>;
};

export const DemoArtistTag = TypedMemo(DemoArtistTagComponent);
